import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  LinearGradient,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

function ShoppingBag(props) {
  return (
    <Svg
      width={49}
      height={49}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_1010_37512)">
        <Path
          d="M21.514 14.602a.366.366 0 00.39-.342c.312-3.492 1.38-6.81 3.009-9.344 1.442-2.244 3.16-3.583 4.595-3.583h.004c5.227.01 6.32 12.794 6.33 12.924.017.209.19.364.386.346.197-.018.342-.202.325-.412C36.51 13.636 35.39.585 29.513.572h-.006c-1.695 0-3.584 1.426-5.183 3.914-1.696 2.638-2.808 6.083-3.131 9.702-.02.209.125.394.321.414z"
          fill="#193E7A"
        />
        <Path
          d="M43.321 40.914l-6.88 3.711-4.168-13.628 6.868-18.27 1.948.508 2.955 26.24c.067.594-.222 1.169-.723 1.44z"
          fill="url(#paint0_radial_1010_37512)"
        />
        <Path
          d="M32.273 30.997l6.868-18.27 1.149.3c.16 2.439.09 4.446-.019 5.908-.46 6.22-1.99 7.952-1.249 12.291.616 3.609 1.961 4.098 1.844 6.526-.128 2.644-1.86 4.858-3.917 6.6l-.508.273-4.168-13.628z"
          fill="#346BC5"
        />
        <Path
          d="M39.142 12.726l-25.909 1.4L5 41.925l31.442 2.7 2.7-31.9z"
          fill="url(#paint1_radial_1010_37512)"
        />
        <Path
          d="M13.233 14.125l13.511-.73c.228.356.53.936.587 1.675.332 4.37-8.76 5.785-9.575 11.15-.62 4.085 3.196 8.798 6.601 10.898 3.588 2.212 6.018 1.092 8.445 3.548 1.066 1.079 1.715 2.428 2.1 3.827L5 41.926l8.234-27.8z"
          fill="url(#paint2_radial_1010_37512)"
          opacity={0.3}
        />
        <Path
          d="M31.195 15.23a.362.362 0 00.347-.294c.073-.331 1.758-8.156-.618-11.996-.681-1.1-1.633-1.772-2.829-1.997C21.952-.21 18.17 13.847 18.012 14.446a.384.384 0 00.247.469c.19.057.387-.061.44-.263.037-.14 3.76-13.997 9.272-12.96 1.01.19 1.78.735 2.357 1.667 2.209 3.57.536 11.325.519 11.403a.382.382 0 00.266.457c.027.007.055.01.082.01z"
          fill="#346BC5"
        />
        <Path
          d="M31.192 16.349c-.55 0-.997-.476-.997-1.062 0-.587.447-1.063.997-1.063.551 0 .998.476.998 1.063 0 .586-.447 1.062-.998 1.062zM18.188 16.25c-.55 0-.997-.475-.997-1.062 0-.587.446-1.063.997-1.063.55 0 .997.476.997 1.063s-.446 1.062-.997 1.062z"
          fill="#346BC5"
        />
        <Path
          d="M11.25 27.503l8.044-7.78a.568.568 0 01.624-.118l4.293 1.859c.362.156.487.635.252.968l-7.006 9.95a.572.572 0 01-.82.136l-5.331-4.028a.66.66 0 01-.056-.987zm9.198-5.045c.271.194.698.022.954-.383.256-.406.244-.892-.027-1.086-.271-.194-.698-.023-.954.383-.256.405-.244.892.027 1.086z"
          fill="#D8DEE8"
        />
        <Path
          d="M11.25 27.397l8.044-7.78a.568.568 0 01.624-.118l4.293 1.859c.362.156.487.635.252.968l-7.006 9.95a.572.572 0 01-.82.136l-5.331-4.028a.66.66 0 01-.056-.987zm9.198-5.045c.271.194.698.022.954-.383.256-.406.244-.892-.027-1.086-.271-.194-.698-.023-.954.383-.256.405-.244.891.027 1.086z"
          fill="#fff"
        />
        <Path
          d="M22.12 20.44c.026 0 .05-.014.061-.04a5.23 5.23 0 011.117-1.672c1.268-1.256 2.905-1.454 4.488-1.645 1.575-.19 3.062-.37 3.951-1.613.225-.314.574-.883.387-1.157-.075-.11-.226-.16-.446-.15a.066.066 0 00-.063.069.065.065 0 00.07.062c.117-.005.27.006.33.093.1.145-.052.54-.386 1.008-.855 1.196-2.314 1.372-3.86 1.558-1.605.194-3.264.394-4.564 1.682a5.357 5.357 0 00-1.145 1.715.065.065 0 00.035.086.065.065 0 00.025.005z"
          fill="#26264F"
        />
        <Path
          d="M21.433 21.758a.065.065 0 00.047-.112c-.006-.006-.556-.558-.554-1.296.002-.453.21-.884.618-1.282.865-.842 3.16-1.819 5.187-2.68 1.236-.526 2.404-1.022 3.17-1.45.175-.098.359-.19.547-.274a.065.065 0 00.033-.087.066.066 0 00-.087-.033 7.2 7.2 0 00-.557.28c-.76.424-1.925.92-3.158 1.444-2.037.865-4.345 1.847-5.228 2.707-.434.423-.655.886-.657 1.376-.002.793.569 1.364.593 1.388.013.012.03.019.046.019z"
          fill="#26264F"
        />
        <Path
          d="M18.468 24.748c-.44.723-.35 1.322.002 1.565.37.256.9.064 1.296-.584.376-.617.396-1.268-.019-1.555-.418-.29-.92-.016-1.279.574zm.889.668c-.22.36-.465.562-.63.448-.16-.11-.096-.399.14-.787.214-.35.447-.575.622-.454.168.117.078.447-.132.793zm-1.798 2.322l.784-4.535-.306-.212-.78 4.538.302.209zm-1.713-2.765c-.44.723-.35 1.323.001 1.566.366.253.897.061 1.296-.585.376-.616.396-1.267-.018-1.554-.419-.29-.92-.017-1.28.573zm.885.665c-.217.364-.462.565-.626.452-.16-.111-.096-.4.14-.788.214-.35.443-.577.618-.456.172.119.078.447-.132.792zM17.39 30.248a.315.315 0 00.273-.164.353.353 0 00-.107-.467l-3.874-2.505a.308.308 0 00-.438.114.353.353 0 00.107.467l3.874 2.505c.052.034.109.05.165.05z"
          fill="#D8DEE8"
        />
        <Path
          d="M22.503 44.727c0 .35.25.65.556.667l21.588 1.308c.409.024.87-.319.87-.725V30.992c0-.405-.473-.747-.882-.73l-21.576.916c-.306.013-.556.309-.556.657v12.892z"
          fill="#3669C6"
        />
        <Path
          d="M22.102 44.752c0 .35.251.652.56.67l21.817 1.283c.411.024.749-.29.749-.697V30.95a.712.712 0 00-.749-.71l-21.818.897c-.308.013-.559.31-.559.66v12.955z"
          fill="url(#paint3_radial_1010_37512)"
        />
        <Path
          d="M22.102 41.222l23.126 1.177v2.757L22.102 43.81v-2.588z"
          fill="url(#paint4_linear_1010_37512)"
        />
        <Path
          d="M38.403 35.22c.026 1.711 1.105 2.6 2.306 2.596 1.31-.005 2.359-1 2.333-2.635-.023-1.554-1.01-2.661-2.477-2.552-1.423.105-2.183 1.195-2.162 2.591zm3.107-.033c.014.893-.28 1.542-.856 1.552-.554.01-.83-.549-.844-1.486-.013-.846.206-1.514.81-1.55.589-.035.877.63.89 1.484zm-1.214 5.502l-4.17-7.487a.423.423 0 00-.4-.215.418.418 0 00-.339.618l4.123 7.485c.07.128.204.21.352.217l.046.002a.419.419 0 00.388-.62zm-7.133-2.11c.024 1.585.95 2.452 1.978 2.497 1.105.048 1.997-.826 1.986-2.332-.022-1.433-.864-2.498-2.115-2.464-1.218.032-1.87 1.005-1.85 2.3zm2.647.104c.024.825-.226 1.41-.718 1.397-.473-.014-.71-.543-.723-1.409-.012-.783.164-1.39.68-1.397.514-.006.75.621.761 1.409z"
          fill="url(#paint5_linear_1010_37512)"
          opacity={0.15}
        />
        <Path
          d="M38.202 35.14c.026 1.711 1.105 2.6 2.306 2.596 1.31-.005 2.358-1 2.333-2.635-.023-1.554-1.01-2.661-2.477-2.552-1.423.105-2.183 1.194-2.162 2.591zm3.107-.033c.014.893-.28 1.542-.856 1.552-.554.01-.83-.549-.844-1.486-.013-.846.206-1.514.81-1.55.589-.035.877.63.89 1.484zm-1.215 5.502l-4.168-7.487a.423.423 0 00-.401-.215.418.418 0 00-.339.618l4.123 7.485c.07.128.204.21.351.217l.047.002a.419.419 0 00.387-.62zm-7.133-2.11c.025 1.585.95 2.452 1.979 2.497 1.105.048 1.997-.826 1.986-2.332-.022-1.433-.864-2.498-2.115-2.464-1.218.032-1.87 1.005-1.85 2.3zm2.648.104c.024.825-.227 1.41-.718 1.397-.473-.014-.71-.543-.723-1.41-.012-.782.164-1.39.68-1.396.514-.006.75.621.761 1.409z"
          fill="#fff"
        />
        <Path
          style={{
            mixBlendMode: 'multiply',
          }}
          opacity={0.3}
          d="M22.406 37.991l.526-.495.5.522.526-.495.5.522.526-.496.499.522.526-.495.5.522.526-.495.5.522.525-.496.5.522.526-.495.5.522.526-.495.499.522.672-.633v7.819s.028.448.573.566l-9.307-.677a.766.766 0 01-.294-.084.722.722 0 01-.152-.443v-7.08l.303.318z"
          fill="url(#paint6_linear_1010_37512)"
        />
        <Path
          d="M20.91 37.731v7.123c0 .397.32.727.719.757l2.951.214 6.377.463c-.546-.118-.558-.566-.558-.566v-7.82l-.685.634-.36-.369-.15-.153-.527.495-.5-.522-.527.496-.5-.522-.526.495-.5-.522-.526.495-.499-.522-.526.496-.5-.522-.526.495-.5-.522-.526.496-.5-.523-.535.496-.576-.591z"
          fill="#fff"
        />
        <Path
          d="M21.984 41.868l1.151.051a.144.144 0 01.138.144v.524c0 .083-.07.148-.153.144l-1.15-.065a.144.144 0 01-.137-.143v-.511c0-.082.069-.147.151-.144zM21.986 42.88l1.15.065a.144.144 0 01.137.143v.547c0 .084-.07.15-.154.144l-1.15-.073a.144.144 0 01-.136-.143v-.54c0-.082.07-.147.153-.143zM21.833 40.416v-.938c0-.081.068-.147.15-.144l1.15.041c.079.003.14.067.14.144v.948a.145.145 0 01-.15.144l-1.152-.052a.144.144 0 01-.138-.143zM24.376 41.974l4.686.21a.144.144 0 01.139.143v.59c0 .083-.07.149-.153.144L24.36 42.8a.144.144 0 01-.137-.143v-.538c0-.082.07-.148.152-.144zM24.377 43.013l4.687.262a.144.144 0 01.137.144v.59c0 .084-.07.15-.154.144l-4.687-.296a.144.144 0 01-.136-.144v-.556c0-.083.07-.148.153-.144zM24.224 40.522v-.96c0-.08.068-.146.15-.143l4.687.167c.078.003.14.067.14.144v1.001a.144.144 0 01-.152.144l-4.686-.21a.144.144 0 01-.139-.143z"
          fill="#D8DEE8"
        />
        <Path
          d="M24.585 45.825l6.374.463c-.546-.118-.56-.566-.56-.566v-7.819l-.686.633-.359-.368c-.3.269-.54.7-.607 1.385-.223 2.277-1.299 2.127-2.569 2.213-1.27.085-1.854 1.543-1.34 2.67.23.503.136 1.011-.253 1.39z"
          fill="#F4F7FA"
          opacity={0.4}
        />
        <Path
          d="M45.817 46.093v.934c0 .301-1.9.546-4.243.546-2.344 0-4.244-.245-4.244-.546v-.934h8.487z"
          fill="url(#paint7_linear_1010_37512)"
        />
        <Path
          d="M37.33 46.093c0 .302 1.9.547 4.244.547s4.244-.245 4.244-.547c0-.302-1.9-.546-4.244-.546-2.343 0-4.243.244-4.243.546z"
          fill="url(#paint8_linear_1010_37512)"
        />
        <Path
          d="M41.574 46.677c2.076 0 4.246-.197 4.246-.576 0-.02-.008-.057-.029-.057-.02 0-.012.028-.012.05 0 .24-1.727.508-4.205.508-2.479 0-4.206-.268-4.206-.509 0-.02-.003-.04-.024-.04s-.016.028-.016.048c0 .38 2.17.576 4.246.576z"
          fill="url(#paint9_linear_1010_37512)"
        />
        <Path
          d="M41.975 46.123a2.268 2.268 0 00-.134-.084.844.844 0 00-.182-.076 1.775 1.775 0 00-.28-.055 3.588 3.588 0 00-.419-.022c-.164 0-.318.004-.462.015-.143.011-.27.028-.38.05a1.18 1.18 0 00-.266.082c-.068.033-.109.07-.122.112l-.478.005a.481.481 0 00-.091.008c-.027.006-.04.013-.04.021v.04l.614-.007c.022.048.077.092.165.131.088.04.2.074.337.103l.224-.03a.265.265 0 00.049-.012c.013-.005.019-.01.019-.015 0-.008-.017-.016-.052-.026a3.031 3.031 0 01-.117-.036 1.191 1.191 0 01-.128-.05.174.174 0 01-.084-.07l1.45-.014a.837.837 0 00.316.154c.078.022.175.04.291.053.117.014.263.02.44.022.133 0 .262-.005.39-.015.126-.01.238-.027.337-.048.098-.021.179-.047.242-.079.063-.031.098-.067.105-.108l.394-.004a.509.509 0 00.093-.008c.027-.005.04-.012.04-.02v-.04l-.537.006c-.024-.041-.073-.077-.147-.108a1.687 1.687 0 00-.273-.081l-.18.024c-.055.008-.082.017-.082.027 0 .006.01.012.033.02l.081.03c.031.011.061.025.09.04a.19.19 0 01.065.052l-1.322.013zm1.327.053c-.011.026-.035.048-.072.067a.575.575 0 01-.136.045c-.055.012-.117.021-.185.027a2.51 2.51 0 01-.442-.004 1.322 1.322 0 01-.171-.028.797.797 0 01-.226-.094l1.232-.013zm-3.157-.034c.01-.026.037-.049.078-.069a.7.7 0 01.157-.049c.064-.013.138-.023.223-.03a3.451 3.451 0 01.515.004c.065.008.122.018.17.03a.634.634 0 01.217.1l-1.36.014z"
          fill="#FCB048"
        />
        <Path
          d="M41.573 45.606c1.892 0 3.862.165 4.178.485a.356.356 0 00-.035.036c-.266-.222-1.892-.446-4.143-.446-2.25 0-3.961.235-4.161.463a.396.396 0 00-.032-.036c.26-.33 2.267-.502 4.193-.502z"
          fill="url(#paint10_linear_1010_37512)"
        />
        <Path
          d="M46.997 45.113v.933c0 .302-1.9.547-4.244.547-2.343 0-4.243-.245-4.243-.547v-.933h8.487z"
          fill="url(#paint11_linear_1010_37512)"
        />
        <Path
          d="M38.51 45.113c0 .301 1.9.546 4.244.546s4.244-.245 4.244-.546c0-.302-1.9-.546-4.244-.546s-4.244.244-4.244.546z"
          fill="url(#paint12_linear_1010_37512)"
        />
        <Path
          d="M42.754 45.697c2.075 0 4.245-.197 4.245-.576 0-.021-.007-.058-.028-.058-.02 0-.012.029-.012.05 0 .24-1.727.508-4.206.508-2.478 0-4.205-.268-4.205-.508 0-.021-.004-.04-.025-.04-.02 0-.016.027-.016.048 0 .38 2.171.576 4.247.576z"
          fill="url(#paint13_linear_1010_37512)"
        />
        <Path
          d="M43.154 45.143a2.25 2.25 0 00-.133-.085.834.834 0 00-.182-.075 1.755 1.755 0 00-.28-.055 3.585 3.585 0 00-.419-.022 5.66 5.66 0 00-.462.015c-.143.011-.27.028-.38.05a1.18 1.18 0 00-.266.082c-.069.033-.11.07-.122.112l-.478.005a.48.48 0 00-.092.008c-.026.006-.04.012-.04.02v.04l.615-.006c.022.048.076.092.165.131.087.04.2.074.337.103l.223-.03a.273.273 0 00.05-.012c.012-.005.019-.01.019-.016 0-.007-.018-.016-.052-.025a2.74 2.74 0 01-.117-.036 1.17 1.17 0 01-.129-.05.174.174 0 01-.084-.07l1.45-.014a.838.838 0 00.316.154c.078.022.176.04.292.053.117.013.263.02.44.021.133 0 .262-.004.389-.015.127-.01.24-.026.337-.048.099-.021.18-.047.243-.078.062-.032.098-.068.105-.108l.393-.004a.509.509 0 00.093-.008c.027-.006.041-.012.041-.021v-.04l-.537.006c-.024-.041-.073-.077-.147-.108a1.687 1.687 0 00-.273-.081l-.18.025c-.055.007-.082.016-.082.026 0 .006.01.013.033.021l.081.03c.03.01.06.024.09.04.029.015.05.032.065.051l-1.322.014zm1.327.053c-.01.026-.035.048-.071.066a.571.571 0 01-.137.046c-.055.012-.116.02-.184.026a2.511 2.511 0 01-.443-.003 1.323 1.323 0 01-.17-.029.804.804 0 01-.227-.093l1.232-.013zm-3.156-.035c.01-.026.037-.048.078-.068a.705.705 0 01.157-.049c.064-.013.138-.023.223-.03a3.5 3.5 0 01.515.003c.065.008.122.018.17.031a.621.621 0 01.217.1l-1.36.013z"
          fill="#FCB048"
        />
        <Path
          d="M42.753 44.625c1.892 0 3.862.166 4.177.485a.355.355 0 00-.034.036c-.266-.222-1.893-.445-4.143-.445s-3.961.235-4.162.463a.396.396 0 00-.032-.036c.26-.331 2.268-.502 4.194-.502z"
          fill="url(#paint14_linear_1010_37512)"
        />
        <Path
          d="M45.979 44.135v.933c0 .302-1.9.547-4.244.547-2.343 0-4.243-.245-4.243-.547v-.933h8.487z"
          fill="url(#paint15_linear_1010_37512)"
        />
        <Path
          d="M37.492 44.135c0 .302 1.9.546 4.244.546s4.244-.244 4.244-.546c0-.302-1.9-.546-4.244-.546s-4.244.244-4.244.546z"
          fill="url(#paint16_linear_1010_37512)"
        />
        <Path
          d="M41.735 44.719c2.076 0 4.246-.197 4.246-.576 0-.021-.007-.058-.028-.058-.02 0-.012.029-.012.05 0 .24-1.727.508-4.206.508-2.478 0-4.205-.268-4.205-.508 0-.021-.004-.04-.025-.04-.02 0-.016.027-.016.048 0 .38 2.17.576 4.247.576z"
          fill="url(#paint17_linear_1010_37512)"
        />
        <Path
          d="M42.136 44.165a2.25 2.25 0 00-.133-.085.837.837 0 00-.182-.075 1.775 1.775 0 00-.28-.055 3.603 3.603 0 00-.42-.022c-.163-.001-.317.004-.46.015-.145.011-.271.028-.38.05-.11.022-.199.05-.267.082-.069.033-.11.07-.122.112l-.478.005a.473.473 0 00-.092.008c-.026.006-.04.012-.04.02v.04l.615-.006c.021.048.076.091.165.131.087.04.2.074.336.103l.224-.03a.26.26 0 00.05-.012c.012-.005.019-.01.019-.016 0-.007-.018-.016-.052-.025a2.74 2.74 0 01-.117-.036 1.17 1.17 0 01-.129-.05.175.175 0 01-.084-.07l1.45-.014a.833.833 0 00.316.154c.078.022.176.04.292.052.117.014.263.02.44.022.133 0 .262-.005.389-.015.126-.01.24-.027.337-.048.099-.021.18-.047.242-.079.063-.03.099-.067.106-.107l.393-.004a.508.508 0 00.093-.008c.027-.006.041-.012.041-.021v-.04l-.537.006c-.024-.041-.073-.077-.147-.108a1.694 1.694 0 00-.273-.08l-.18.024c-.055.007-.082.016-.082.026 0 .006.01.013.033.02l.08.03c.032.012.062.025.09.04.03.016.051.033.066.052l-1.322.013v.001zm1.327.053c-.01.026-.035.048-.071.066a.574.574 0 01-.137.046c-.054.012-.116.02-.184.026a2.514 2.514 0 01-.443-.003 1.322 1.322 0 01-.17-.029.797.797 0 01-.226-.093l1.231-.013zm-3.156-.035c.01-.026.037-.048.078-.068a.705.705 0 01.157-.049c.064-.013.138-.023.223-.03a3.45 3.45 0 01.515.003c.065.008.122.018.17.031a.618.618 0 01.217.1l-1.36.014z"
          fill="#FCB048"
        />
        <Path
          d="M41.735 43.648c1.892 0 3.862.165 4.177.484a.365.365 0 00-.034.036c-.266-.222-1.893-.445-4.143-.445s-3.962.235-4.162.463a.382.382 0 00-.032-.036c.26-.331 2.268-.502 4.194-.502z"
          fill="url(#paint18_linear_1010_37512)"
        />
        <Path
          d="M45.361 43.153v.934c0 .301-1.9.546-4.243.546-2.344 0-4.244-.244-4.244-.546v-.934h8.487z"
          fill="url(#paint19_linear_1010_37512)"
        />
        <Path
          d="M41.118 43.7c-2.343 0-4.243-.245-4.243-.547 0-.301 1.9-.546 4.243-.546 2.344 0 4.244.245 4.244.546 0 .302-1.9.547-4.244.547z"
          fill="url(#paint20_linear_1010_37512)"
        />
        <Path
          d="M41.118 43.737c2.075 0 4.246-.197 4.246-.576 0-.02-.008-.057-.029-.057-.02 0-.012.028-.012.05 0 .24-1.727.508-4.205.508-2.479 0-4.206-.268-4.206-.509 0-.02-.003-.04-.024-.04s-.016.028-.016.049c0 .379 2.17.575 4.246.575z"
          fill="url(#paint21_linear_1010_37512)"
        />
        <Path
          d="M41.518 43.184a2.25 2.25 0 00-.133-.085.846.846 0 00-.182-.075 1.776 1.776 0 00-.28-.055 3.604 3.604 0 00-.419-.023c-.164 0-.318.005-.462.016-.143.01-.27.027-.38.05-.109.021-.198.049-.266.082-.068.032-.109.07-.122.112l-.478.004a.458.458 0 00-.091.009c-.027.005-.04.012-.04.02v.04l.614-.006c.022.047.077.091.165.13.088.04.2.075.337.104l.223-.031a.274.274 0 00.05-.012c.013-.004.019-.01.019-.015 0-.007-.017-.016-.052-.026a2.696 2.696 0 01-.117-.035 1.164 1.164 0 01-.128-.05.174.174 0 01-.084-.07l1.45-.014a.84.84 0 00.316.154c.078.021.175.04.291.053.117.013.263.02.44.02.133.002.262-.004.39-.014.126-.01.238-.027.337-.048.098-.021.179-.047.242-.079.063-.03.098-.067.105-.107l.394-.004a.51.51 0 00.093-.008c.027-.006.04-.012.04-.021v-.04l-.537.006c-.024-.041-.072-.077-.147-.107a1.69 1.69 0 00-.273-.082l-.18.025c-.055.007-.082.016-.082.026 0 .006.011.013.034.021l.08.03c.03.01.061.024.09.04a.19.19 0 01.065.052l-1.321.013zm1.327.053c-.01.025-.035.047-.071.066a.573.573 0 01-.137.046c-.054.012-.116.02-.184.026a2.513 2.513 0 01-.443-.003 1.322 1.322 0 01-.17-.029.794.794 0 01-.227-.094l1.232-.012zm-3.156-.035c.01-.026.037-.049.078-.068a.705.705 0 01.157-.05c.064-.013.138-.023.223-.029a3.45 3.45 0 01.515.003c.065.008.122.018.17.03a.634.634 0 01.217.1l-1.36.014z"
          fill="#FCB048"
        />
        <Path
          d="M41.117 42.666c1.892 0 3.862.165 4.177.485a.365.365 0 00-.034.036c-.266-.222-1.892-.446-4.143-.446-2.25 0-3.961.236-4.161.463a.382.382 0 00-.032-.036c.26-.33 2.267-.502 4.193-.502z"
          fill="url(#paint22_linear_1010_37512)"
        />
        <Path
          d="M45.817 42.095v.934c0 .301-1.9.546-4.243.546-2.344 0-4.244-.244-4.244-.546v-.934h8.487z"
          fill="url(#paint23_linear_1010_37512)"
        />
        <Path
          d="M37.33 42.095c0 .302 1.9.547 4.244.547s4.244-.245 4.244-.547c0-.301-1.9-.546-4.244-.546-2.343 0-4.243.245-4.243.546z"
          fill="url(#paint24_linear_1010_37512)"
        />
        <Path
          d="M41.574 42.68c2.076 0 4.246-.198 4.246-.577 0-.02-.008-.057-.029-.057-.02 0-.012.028-.012.05 0 .24-1.727.508-4.205.508-2.479 0-4.206-.268-4.206-.509 0-.02-.003-.04-.024-.04s-.016.028-.016.048c0 .38 2.17.576 4.246.576z"
          fill="url(#paint25_linear_1010_37512)"
        />
        <Path
          d="M41.975 42.126a2.217 2.217 0 00-.134-.085.834.834 0 00-.182-.075 1.762 1.762 0 00-.28-.056 3.588 3.588 0 00-.419-.022c-.164 0-.318.005-.462.016-.143.01-.27.027-.38.05a1.18 1.18 0 00-.266.081c-.068.033-.109.07-.122.113l-.478.004a.48.48 0 00-.091.009c-.027.005-.04.012-.04.02v.04l.614-.007c.022.048.077.092.165.132.088.04.2.073.337.103l.224-.031a.273.273 0 00.049-.012c.013-.005.019-.01.019-.015 0-.008-.017-.016-.052-.026a2.878 2.878 0 01-.117-.036 1.191 1.191 0 01-.128-.05.174.174 0 01-.084-.07l1.45-.014a.837.837 0 00.316.154c.078.022.175.04.291.053.117.013.263.02.44.021.133.001.262-.004.39-.015.126-.01.238-.026.337-.047.098-.022.179-.048.242-.08.063-.03.098-.066.105-.107l.394-.004a.509.509 0 00.093-.008c.027-.005.04-.012.04-.02v-.04l-.537.005c-.024-.04-.073-.077-.147-.107a1.688 1.688 0 00-.273-.082l-.18.025c-.055.008-.082.016-.082.027 0 .005.01.012.033.02l.081.03c.031.011.061.024.09.04a.19.19 0 01.065.052l-1.322.013zm1.327.053c-.011.025-.035.047-.072.066a.57.57 0 01-.136.046c-.055.012-.117.02-.185.026a2.47 2.47 0 01-.442-.004 1.322 1.322 0 01-.171-.028.787.787 0 01-.226-.094l1.232-.012zm-3.157-.035c.01-.026.037-.049.078-.068a.711.711 0 01.157-.05c.064-.013.138-.023.223-.03a3.451 3.451 0 01.515.004c.065.008.122.018.17.03a.64.64 0 01.217.1l-1.36.014z"
          fill="#FCB048"
        />
        <Path
          d="M41.573 41.608c1.892 0 3.862.165 4.178.485a.367.367 0 00-.035.036c-.266-.222-1.892-.446-4.143-.446-2.25 0-3.961.236-4.161.463a.396.396 0 00-.032-.036c.26-.33 2.267-.502 4.193-.502z"
          fill="url(#paint26_linear_1010_37512)"
        />
        <Path
          d="M46.997 41.115v.934c0 .301-1.9.546-4.244.546-2.343 0-4.243-.245-4.243-.546v-.934h8.487z"
          fill="url(#paint27_linear_1010_37512)"
        />
        <Path
          d="M42.754 41.661c-2.344 0-4.244-.244-4.244-.546 0-.302 1.9-.546 4.244-.546s4.244.244 4.244.546c0 .302-1.9.546-4.244.546z"
          fill="url(#paint28_linear_1010_37512)"
        />
        <Path
          d="M42.754 41.699c2.075 0 4.245-.197 4.245-.576 0-.02-.007-.057-.028-.057-.02 0-.012.028-.012.049 0 .24-1.727.508-4.206.508-2.478 0-4.205-.267-4.205-.508 0-.02-.004-.04-.025-.04-.02 0-.016.027-.016.048 0 .38 2.171.576 4.247.576z"
          fill="url(#paint29_linear_1010_37512)"
        />
        <Path
          d="M43.154 41.145a2.25 2.25 0 00-.133-.084.839.839 0 00-.182-.076 1.777 1.777 0 00-.28-.055 3.588 3.588 0 00-.419-.022c-.164-.001-.318.004-.462.015-.143.011-.27.028-.38.05-.109.022-.198.05-.266.082-.069.033-.11.07-.122.112l-.478.005a.49.49 0 00-.092.008c-.026.006-.04.013-.04.021v.04l.615-.007c.022.048.076.092.165.131.087.04.2.074.337.103l.223-.03a.265.265 0 00.05-.012c.012-.005.019-.01.019-.016 0-.007-.018-.016-.052-.025a2.74 2.74 0 01-.117-.036 1.17 1.17 0 01-.129-.05.174.174 0 01-.084-.07l1.45-.014a.838.838 0 00.316.154c.078.022.176.04.292.053.117.013.263.02.44.021.133 0 .262-.004.389-.015.127-.01.24-.026.337-.048.099-.02.18-.047.243-.078.062-.032.098-.068.105-.108l.393-.004a.509.509 0 00.093-.008c.027-.006.041-.013.041-.021v-.04l-.537.006c-.024-.041-.073-.077-.147-.108a1.688 1.688 0 00-.273-.081l-.18.024c-.055.008-.082.017-.082.027 0 .006.01.013.033.02l.081.03c.03.012.06.025.09.04a.19.19 0 01.065.053l-1.322.013zm1.327.053c-.01.026-.035.048-.071.067a.576.576 0 01-.137.045c-.055.012-.116.021-.184.027a2.472 2.472 0 01-.443-.004 1.322 1.322 0 01-.17-.028.784.784 0 01-.227-.094l1.232-.012zm-3.156-.034c.01-.026.037-.049.078-.069a.706.706 0 01.157-.049 1.79 1.79 0 01.223-.03 3.5 3.5 0 01.515.004c.065.007.122.017.17.03a.635.635 0 01.217.1l-1.36.014z"
          fill="#FCB048"
        />
        <Path
          d="M42.753 40.628c1.892 0 3.862.165 4.177.485a.346.346 0 00-.034.036c-.266-.222-1.893-.446-4.143-.446s-3.961.235-4.162.463a.396.396 0 00-.032-.036c.26-.331 2.268-.502 4.194-.502z"
          fill="url(#paint30_linear_1010_37512)"
        />
        <Path
          d="M45.979 40.137v.934c0 .301-1.9.546-4.244.546-2.343 0-4.243-.245-4.243-.546v-.934h8.487z"
          fill="url(#paint31_linear_1010_37512)"
        />
        <Path
          d="M41.736 40.683c-2.344 0-4.244-.244-4.244-.546 0-.302 1.9-.546 4.244-.546s4.244.244 4.244.546c0 .302-1.9.546-4.244.546z"
          fill="url(#paint32_linear_1010_37512)"
        />
        <Path
          d="M41.735 40.72c2.076 0 4.246-.196 4.246-.575 0-.021-.007-.058-.028-.058-.02 0-.012.029-.012.05 0 .24-1.727.508-4.206.508-2.478 0-4.205-.268-4.205-.508 0-.021-.004-.04-.025-.04-.02 0-.016.027-.016.048 0 .38 2.17.576 4.247.576z"
          fill="url(#paint33_linear_1010_37512)"
        />
        <Path
          d="M42.136 40.167a2.302 2.302 0 00-.133-.084.846.846 0 00-.182-.076 1.775 1.775 0 00-.28-.055 3.584 3.584 0 00-.42-.022c-.163-.001-.317.004-.46.015-.145.011-.271.028-.38.05a1.18 1.18 0 00-.267.082c-.069.033-.11.07-.122.112l-.478.005a.49.49 0 00-.092.008c-.026.006-.04.013-.04.02v.04l.615-.006c.021.048.076.091.165.131.087.04.2.074.336.103l.224-.03a.276.276 0 00.05-.013c.012-.004.019-.01.019-.015 0-.007-.018-.016-.052-.025a2.74 2.74 0 01-.117-.036 1.17 1.17 0 01-.129-.05.174.174 0 01-.084-.07l1.45-.014a.838.838 0 00.316.154c.078.022.176.04.292.052.117.014.263.021.44.022.133 0 .262-.005.389-.015.126-.01.24-.027.337-.048.099-.021.18-.047.242-.079.063-.03.099-.067.106-.107l.393-.005a.508.508 0 00.093-.008c.027-.005.041-.012.041-.02v-.04l-.537.006c-.024-.041-.073-.077-.147-.108a1.694 1.694 0 00-.273-.081l-.18.024c-.055.008-.082.017-.082.027 0 .005.01.012.033.02l.08.03c.032.011.062.025.09.04.03.016.051.033.066.052l-1.322.013v.001zm1.327.053c-.01.026-.035.048-.071.066a.574.574 0 01-.137.046c-.054.012-.116.021-.184.027a2.473 2.473 0 01-.443-.004 1.322 1.322 0 01-.17-.028.787.787 0 01-.226-.094l1.231-.013zm-3.156-.035c.01-.025.037-.048.078-.068a.706.706 0 01.157-.049 1.79 1.79 0 01.223-.03 3.5 3.5 0 01.515.004c.065.007.122.017.17.03a.63.63 0 01.217.1l-1.36.014z"
          fill="#FCB048"
        />
        <Path
          d="M41.735 39.65c1.892 0 3.862.165 4.177.485a.366.366 0 00-.034.036c-.266-.222-1.893-.446-4.143-.446s-3.962.235-4.162.463a.382.382 0 00-.032-.036c.26-.331 2.268-.502 4.194-.502z"
          fill="url(#paint34_linear_1010_37512)"
        />
        <Path
          d="M46.508 39.157v.933c0 .302-1.9.546-4.243.546-2.344 0-4.244-.244-4.244-.546v-.934h8.487z"
          fill="url(#paint35_linear_1010_37512)"
        />
        <Path
          d="M42.265 39.703c-2.343 0-4.243-.245-4.243-.546 0-.302 1.9-.547 4.243-.547 2.344 0 4.244.245 4.244.547 0 .302-1.9.546-4.244.546z"
          fill="url(#paint36_linear_1010_37512)"
        />
        <Path
          d="M42.265 39.74c2.075 0 4.246-.196 4.246-.576 0-.02-.008-.057-.029-.057-.02 0-.012.029-.012.05 0 .24-1.727.508-4.205.508-2.479 0-4.206-.268-4.206-.508 0-.021-.003-.04-.024-.04s-.016.027-.016.048c0 .38 2.17.575 4.246.575z"
          fill="url(#paint37_linear_1010_37512)"
        />
        <Path
          d="M42.264 38.67c1.892 0 3.862.164 4.177.484a.365.365 0 00-.034.036c-.266-.222-1.892-.445-4.143-.445-2.25 0-3.961.235-4.162.462a.395.395 0 00-.031-.035c.26-.331 2.267-.503 4.193-.503z"
          fill="url(#paint38_linear_1010_37512)"
        />
        <Path
          d="M36.814 39.816l.767.54c.248.176-.652 1.853-2.01 3.747-1.359 1.895-2.661 3.289-2.909 3.114l-.767-.541 4.92-6.86z"
          fill="url(#paint39_radial_1010_37512)"
        />
        <Path
          d="M31.895 46.675c.248.175 1.55-1.219 2.909-3.113 1.358-1.895 2.258-3.572 2.01-3.747-.247-.175-1.55 1.22-2.908 3.114-1.358 1.894-2.259 3.571-2.01 3.746z"
          fill="url(#paint40_linear_1010_37512)"
        />
        <Path
          d="M34.834 43.584c1.203-1.678 2.3-3.546 1.988-3.766-.017-.012-.051-.027-.063-.01-.013.017.016.026.033.038.198.14-.583 1.691-2.02 3.694-1.436 2.004-2.657 3.245-2.855 3.105-.017-.012-.035-.02-.047-.004-.013.017.013.03.03.041.312.22 1.731-1.42 2.934-3.098z"
          fill="url(#paint41_linear_1010_37512)"
        />
        <Path
          d="M33.954 42.964c1.097-1.53 2.375-3.026 2.82-3.096a.342.342 0 00.01.05c-.337.085-1.463 1.27-2.768 3.09-1.338 1.865-2.102 3.338-2.032 3.631a.422.422 0 00-.047.005c-.121-.402.901-2.124 2.017-3.68z"
          fill="url(#paint42_linear_1010_37512)"
        />
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_1010_37512"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(9.9476 28.8891 -16.54028 5.69544 33.17 14.803)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_1010_37512"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(28.82892 28.88906 -26.86527 26.80934 7.597 14.803)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint2_radial_1010_37512"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(48.121 -13.63 15.856) scale(37.8248 34.9665)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint3_radial_1010_37512"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(20.33082 15.4345 -12.98417 17.10316 25.76 31.221)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <LinearGradient
          id="paint4_linear_1010_37512"
          x1={39.5889}
          y1={41.3336}
          x2={20.0138}
          y2={47.5655}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#444B8C" />
          <Stop offset={1} stopColor="#26264F" />
        </LinearGradient>
        <LinearGradient
          id="paint5_linear_1010_37512"
          x1={43.0723}
          y1={36.9243}
          x2={33.1431}
          y2={37.0763}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FF9085" />
          <Stop offset={1} stopColor="#FB6FBB" />
        </LinearGradient>
        <LinearGradient
          id="paint6_linear_1010_37512"
          x1={31.8561}
          y1={41.7262}
          x2={22.1024}
          y2={41.7262}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#AA80F9" />
          <Stop offset={1} stopColor="#6165D7" />
        </LinearGradient>
        <LinearGradient
          id="paint7_linear_1010_37512"
          x1={46.5428}
          y1={46.833}
          x2={36.7789}
          y2={46.833}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FCB148" />
          <Stop offset={0.05} stopColor="#FDB946" />
          <Stop offset={0.14} stopColor="#FEC144" />
          <Stop offset={0.32} stopColor="#FFC444" />
          <Stop offset={0.48} stopColor="#FDB946" />
          <Stop offset={0.78} stopColor="#F99C4C" />
          <Stop offset={0.87} stopColor="#F8924F" />
          <Stop offset={1} stopColor="#F8924F" />
        </LinearGradient>
        <LinearGradient
          id="paint8_linear_1010_37512"
          x1={41.6164}
          y1={45.7421}
          x2={41.11}
          y2={50.0176}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint9_linear_1010_37512"
          x1={41.6384}
          y1={45.5513}
          x2={41.4829}
          y2={46.8645}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint10_linear_1010_37512"
          x1={41.4897}
          y1={46.7265}
          x2={41.6448}
          y2={45.4181}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F36F56" />
          <Stop offset={0.31} stopColor="#F99C4C" />
          <Stop offset={0.55} stopColor="#FDB946" />
          <Stop offset={0.68} stopColor="#FFC444" />
          <Stop offset={0.8} stopColor="#FEC144" />
          <Stop offset={0.87} stopColor="#FDB946" />
          <Stop offset={0.92} stopColor="#FBAC49" />
          <Stop offset={0.96} stopColor="#F8994D" />
          <Stop offset={1} stopColor="#F57E53" />
        </LinearGradient>
        <LinearGradient
          id="paint11_linear_1010_37512"
          x1={47.7225}
          y1={45.8527}
          x2={37.9585}
          y2={45.8527}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FCB148" />
          <Stop offset={0.05} stopColor="#FDB946" />
          <Stop offset={0.14} stopColor="#FEC144" />
          <Stop offset={0.32} stopColor="#FFC444" />
          <Stop offset={0.48} stopColor="#FDB946" />
          <Stop offset={0.78} stopColor="#F99C4C" />
          <Stop offset={0.87} stopColor="#F8924F" />
          <Stop offset={1} stopColor="#F8924F" />
        </LinearGradient>
        <LinearGradient
          id="paint12_linear_1010_37512"
          x1={42.7961}
          y1={44.762}
          x2={42.2897}
          y2={49.0372}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint13_linear_1010_37512"
          x1={42.8181}
          y1={44.5712}
          x2={42.6626}
          y2={45.8841}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint14_linear_1010_37512"
          x1={42.6694}
          y1={45.7461}
          x2={42.8244}
          y2={44.4378}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F36F56" />
          <Stop offset={0.31} stopColor="#F99C4C" />
          <Stop offset={0.55} stopColor="#FDB946" />
          <Stop offset={0.68} stopColor="#FFC444" />
          <Stop offset={0.8} stopColor="#FEC144" />
          <Stop offset={0.87} stopColor="#FDB946" />
          <Stop offset={0.92} stopColor="#FBAC49" />
          <Stop offset={0.96} stopColor="#F8994D" />
          <Stop offset={1} stopColor="#F57E53" />
        </LinearGradient>
        <LinearGradient
          id="paint15_linear_1010_37512"
          x1={46.7046}
          y1={44.8747}
          x2={36.9406}
          y2={44.8747}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FCB148" />
          <Stop offset={0.05} stopColor="#FDB946" />
          <Stop offset={0.14} stopColor="#FEC144" />
          <Stop offset={0.32} stopColor="#FFC444" />
          <Stop offset={0.48} stopColor="#FDB946" />
          <Stop offset={0.78} stopColor="#F99C4C" />
          <Stop offset={0.87} stopColor="#F8924F" />
          <Stop offset={1} stopColor="#F8924F" />
        </LinearGradient>
        <LinearGradient
          id="paint16_linear_1010_37512"
          x1={41.778}
          y1={43.784}
          x2={41.2714}
          y2={48.0593}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint17_linear_1010_37512"
          x1={41.8}
          y1={43.593}
          x2={41.6443}
          y2={44.906}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint18_linear_1010_37512"
          x1={41.6513}
          y1={44.768}
          x2={41.8064}
          y2={43.4596}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F36F56" />
          <Stop offset={0.31} stopColor="#F99C4C" />
          <Stop offset={0.55} stopColor="#FDB946" />
          <Stop offset={0.68} stopColor="#FFC444" />
          <Stop offset={0.8} stopColor="#FEC144" />
          <Stop offset={0.87} stopColor="#FDB946" />
          <Stop offset={0.92} stopColor="#FBAC49" />
          <Stop offset={0.96} stopColor="#F8994D" />
          <Stop offset={1} stopColor="#F57E53" />
        </LinearGradient>
        <LinearGradient
          id="paint19_linear_1010_37512"
          x1={46.0869}
          y1={43.8932}
          x2={36.3228}
          y2={43.8932}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FCB148" />
          <Stop offset={0.05} stopColor="#FDB946" />
          <Stop offset={0.14} stopColor="#FEC144" />
          <Stop offset={0.32} stopColor="#FFC444" />
          <Stop offset={0.48} stopColor="#FDB946" />
          <Stop offset={0.78} stopColor="#F99C4C" />
          <Stop offset={0.87} stopColor="#F8924F" />
          <Stop offset={1} stopColor="#F8924F" />
        </LinearGradient>
        <LinearGradient
          id="paint20_linear_1010_37512"
          x1={41.1605}
          y1={42.8023}
          x2={40.6539}
          y2={47.0778}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint21_linear_1010_37512"
          x1={41.1824}
          y1={42.6115}
          x2={41.0268}
          y2={43.9246}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint22_linear_1010_37512"
          x1={41.0335}
          y1={43.7866}
          x2={41.1885}
          y2={42.4783}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F36F56" />
          <Stop offset={0.31} stopColor="#F99C4C" />
          <Stop offset={0.55} stopColor="#FDB946" />
          <Stop offset={0.68} stopColor="#FFC444" />
          <Stop offset={0.8} stopColor="#FEC144" />
          <Stop offset={0.87} stopColor="#FDB946" />
          <Stop offset={0.92} stopColor="#FBAC49" />
          <Stop offset={0.96} stopColor="#F8994D" />
          <Stop offset={1} stopColor="#F57E53" />
        </LinearGradient>
        <LinearGradient
          id="paint23_linear_1010_37512"
          x1={46.9995}
          y1={42.8351}
          x2={46.9823}
          y2={42.8351}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FCB148" />
          <Stop offset={0.05} stopColor="#FDB946" />
          <Stop offset={0.14} stopColor="#FEC144" />
          <Stop offset={0.32} stopColor="#FFC444" />
          <Stop offset={0.48} stopColor="#FDB946" />
          <Stop offset={0.78} stopColor="#F99C4C" />
          <Stop offset={0.87} stopColor="#F8924F" />
          <Stop offset={1} stopColor="#F8924F" />
        </LinearGradient>
        <LinearGradient
          id="paint24_linear_1010_37512"
          x1={41.6164}
          y1={41.7444}
          x2={41.11}
          y2={46.0197}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint25_linear_1010_37512"
          x1={41.6384}
          y1={41.5535}
          x2={41.4829}
          y2={42.8664}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint26_linear_1010_37512"
          x1={41.4897}
          y1={42.7286}
          x2={41.6448}
          y2={41.4202}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F36F56" />
          <Stop offset={0.31} stopColor="#F99C4C" />
          <Stop offset={0.55} stopColor="#FDB946" />
          <Stop offset={0.68} stopColor="#FFC444" />
          <Stop offset={0.8} stopColor="#FEC144" />
          <Stop offset={0.87} stopColor="#FDB946" />
          <Stop offset={0.92} stopColor="#FBAC49" />
          <Stop offset={0.96} stopColor="#F8994D" />
          <Stop offset={1} stopColor="#F57E53" />
        </LinearGradient>
        <LinearGradient
          id="paint27_linear_1010_37512"
          x1={47.7225}
          y1={41.8549}
          x2={37.9585}
          y2={41.8549}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FCB148" />
          <Stop offset={0.05} stopColor="#FDB946" />
          <Stop offset={0.14} stopColor="#FEC144" />
          <Stop offset={0.32} stopColor="#FFC444" />
          <Stop offset={0.48} stopColor="#FDB946" />
          <Stop offset={0.78} stopColor="#F99C4C" />
          <Stop offset={0.87} stopColor="#F8924F" />
          <Stop offset={1} stopColor="#F8924F" />
        </LinearGradient>
        <LinearGradient
          id="paint28_linear_1010_37512"
          x1={42.7961}
          y1={40.764}
          x2={42.2897}
          y2={45.0395}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint29_linear_1010_37512"
          x1={42.8181}
          y1={40.5732}
          x2={42.6626}
          y2={41.8864}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint30_linear_1010_37512"
          x1={42.6694}
          y1={41.7484}
          x2={42.8244}
          y2={40.44}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F36F56" />
          <Stop offset={0.31} stopColor="#F99C4C" />
          <Stop offset={0.55} stopColor="#FDB946" />
          <Stop offset={0.68} stopColor="#FFC444" />
          <Stop offset={0.8} stopColor="#FEC144" />
          <Stop offset={0.87} stopColor="#FDB946" />
          <Stop offset={0.92} stopColor="#FBAC49" />
          <Stop offset={0.96} stopColor="#F8994D" />
          <Stop offset={1} stopColor="#F57E53" />
        </LinearGradient>
        <LinearGradient
          id="paint31_linear_1010_37512"
          x1={46.7046}
          y1={40.8768}
          x2={36.9406}
          y2={40.8768}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FCB148" />
          <Stop offset={0.05} stopColor="#FDB946" />
          <Stop offset={0.14} stopColor="#FEC144" />
          <Stop offset={0.32} stopColor="#FFC444" />
          <Stop offset={0.48} stopColor="#FDB946" />
          <Stop offset={0.78} stopColor="#F99C4C" />
          <Stop offset={0.87} stopColor="#F8924F" />
          <Stop offset={1} stopColor="#F8924F" />
        </LinearGradient>
        <LinearGradient
          id="paint32_linear_1010_37512"
          x1={41.778}
          y1={39.7861}
          x2={41.2714}
          y2={44.0614}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint33_linear_1010_37512"
          x1={41.8}
          y1={39.5952}
          x2={41.6443}
          y2={40.9083}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint34_linear_1010_37512"
          x1={41.6513}
          y1={40.7703}
          x2={41.8064}
          y2={39.4619}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F36F56" />
          <Stop offset={0.31} stopColor="#F99C4C" />
          <Stop offset={0.55} stopColor="#FDB946" />
          <Stop offset={0.68} stopColor="#FFC444" />
          <Stop offset={0.8} stopColor="#FEC144" />
          <Stop offset={0.87} stopColor="#FDB946" />
          <Stop offset={0.92} stopColor="#FBAC49" />
          <Stop offset={0.96} stopColor="#F8994D" />
          <Stop offset={1} stopColor="#F57E53" />
        </LinearGradient>
        <LinearGradient
          id="paint35_linear_1010_37512"
          x1={47.2339}
          y1={39.8963}
          x2={37.4699}
          y2={39.8963}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FCB148" />
          <Stop offset={0.05} stopColor="#FDB946" />
          <Stop offset={0.14} stopColor="#FEC144" />
          <Stop offset={0.32} stopColor="#FFC444" />
          <Stop offset={0.48} stopColor="#FDB946" />
          <Stop offset={0.78} stopColor="#F99C4C" />
          <Stop offset={0.87} stopColor="#F8924F" />
          <Stop offset={1} stopColor="#F8924F" />
        </LinearGradient>
        <LinearGradient
          id="paint36_linear_1010_37512"
          x1={42.3075}
          y1={38.8056}
          x2={41.8009}
          y2={43.0811}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint37_linear_1010_37512"
          x1={42.3293}
          y1={38.6148}
          x2={42.1738}
          y2={39.9278}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint38_linear_1010_37512"
          x1={42.1806}
          y1={39.7898}
          x2={42.3355}
          y2={38.4814}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F36F56" />
          <Stop offset={0.31} stopColor="#F99C4C" />
          <Stop offset={0.55} stopColor="#FDB946" />
          <Stop offset={0.68} stopColor="#FFC444" />
          <Stop offset={0.8} stopColor="#FEC144" />
          <Stop offset={0.87} stopColor="#FDB946" />
          <Stop offset={0.92} stopColor="#FBAC49" />
          <Stop offset={0.96} stopColor="#F8994D" />
          <Stop offset={1} stopColor="#F57E53" />
        </LinearGradient>
        <RadialGradient
          id="paint39_radial_1010_37512"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(5.03515 6.95112 -5.76844 4.17846 32.801 40.258)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <LinearGradient
          id="paint40_linear_1010_37512"
          x1={34.0928}
          y1={43.0069}
          x2={37.2822}
          y2={45.9256}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint41_linear_1010_37512"
          x1={33.9491}
          y1={42.8787}
          x2={34.9286}
          y2={43.7751}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFDB44" />
          <Stop offset={1} stopColor="#FEEF06" />
        </LinearGradient>
        <LinearGradient
          id="paint42_linear_1010_37512"
          x1={34.8269}
          y1={43.6819}
          x2={33.8509}
          y2={42.7886}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F36F56" />
          <Stop offset={0.31} stopColor="#F99C4C" />
          <Stop offset={0.55} stopColor="#FDB946" />
          <Stop offset={0.68} stopColor="#FFC444" />
          <Stop offset={0.8} stopColor="#FEC144" />
          <Stop offset={0.87} stopColor="#FDB946" />
          <Stop offset={0.92} stopColor="#FBAC49" />
          <Stop offset={0.96} stopColor="#F8994D" />
          <Stop offset={1} stopColor="#F57E53" />
        </LinearGradient>
        <ClipPath id="clip0_1010_37512">
          <Path
            fill="#fff"
            transform="matrix(-1 0 0 1 47 .572)"
            d="M0 0H42V47H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default ShoppingBag
